<template>
  <div>
    <!-- header  -->
    <section
      :class="
        userData.isAndroid
          ? 'padding-nevigate-bar-ANDROID'
          : 'padding-nevigate-bar-IOS'
      "
      v-if="userData.channel != 'WEB'"
    >
      <div class="row no-gutters">
        <div class="col-2 pl-2 justify-content-center align-self-center">
          <div @click="goToPreviousPage()">
            <b-icon
              class="text-kanit-color-black"
              icon="chevron-left"
              style="width: 24px; height: 24px"
            />
          </div>
        </div>
        <div class="col-8 justify-content-center align-self-center">
          <div class="mx-0 text-center font-kanit-bold-20">
            {{ this.currentMenu.pageName }}
          </div>
        </div>
        <div class="col-2 px-0"></div>
      </div>
    </section>

    <div
      class="justify-content-md-center d-flex flex-column justify-content-between h-100 p-3"
      :style="userData.isAndroid ? '' : 'overflow-y: scroll;'"
      style="height: 95vh !important"
    >
      <div class="">
        <!-- Imaage -->
        <div class="row">
          <div class="col-md-4 justify-content-center align-self-center">
            <div class="">
              <div class="row" style="">
                <div
                  class="offset-2 col-8 offset-md-1 col-md-10 justify-content-center align-self-center"
                >
                  <template>
                    <b-img-lazy
                      center
                      class="image"
                      :src="imgBgNEXT"
                      width="240"
                      height="168"
                    />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Choose -->
        <b-row class="pt-3 pb-4">
          <b-col>
            <span class="font-kanit-bold-20">เลือกวิธีแนบเอกสาร Statement</span>
          </b-col>
        </b-row>
        <!-- Choose option -->
        <b-card
          v-for="(item, key) in updateType"
          :key="key"
          class="border-radius-1rem mb-3"
          :body-class="item.active_flag ? 'p-3' : 'p-3 card-disable'"
          @click="goTo(item.type, item.active_flag)"
          style="cursor: pointer; line-height: 1.25"
        >
          <b-row>
            <b-col>
              <b-row class="upload-type">
                <template v-if="item.type == 1">
                  <div class="px-3">
                    <span
                      class="font-kanit-regular-14"
                      style="
                        color: #4457e3;
                        background: #e1eaf9;
                        border-radius: 16px;
                        padding: 2px 8px;
                        width: 52px;
                        height: 25px;
                        line-height: 24px;
                      "
                      >แนะนำ</span
                    >
                  </div>

                  <div class="w-100"></div>
                </template>
                <b-col class="title" align-self="center">
                  <span
                    :style="
                      item.type == 1
                        ? ' line-height: 24px;vertical-align: sub;'
                        : ''
                    "
                    class="font-kanit-bold-16"
                  >
                    {{ item.uploads_message }}
                  </span>
                </b-col>
                <div class="w-100" />
                <template v-if="item.type == 1 && objAcc.length == 0">
                  <b-col
                    class="font-kanit-regular-16 text-kanit-color-grey"
                    align-self="center"
                  >
                    {{ item.uploads_desc_message }}</b-col
                  >
                </template>
                <template v-if="item.type == 2 && getSizeUpload() == ''">
                  <b-col
                    class="font-kanit-regular-16 text-kanit-color-grey"
                    align-self="center"
                    v-if="
                      'RESUBMIT' !== userData.followupStatus.code 
                    "
                  >
                    {{ item.uploads_desc_message }}</b-col
                  >
                </template>
                
                <template v-if="item.type == 3 && !dStatementSelected">
                  <b-col
                    class="font-kanit-regular-16 text-kanit-color-grey"
                    align-self="center"
                  >
                    {{ item.uploads_desc_message }}</b-col
                  >
                </template>
              </b-row>
            </b-col>
            <b-col cols="auto" align-self="center" style="" class="pl-0">
              <b-icon
                v-if="item.active_flag"
                icon="chevron-right"
                font-scale="1.3"
                style="color: #838383"
              />
            </b-col>
          </b-row>
          <b-row v-if="item.type == 1 && objAcc.length > 0">
            <span
              class="px-3 text-kanit-color-blue font-kanit-regular-14"
              :class="
                checkDocIsSuccess()
                  ? 'text-kanit-color-success'
                  : 'text-kanit-color-blue'
              "
            >
              {{
                checkDocIsSuccess()
                  ? "อัปโหลดสำเร็จ"
                  : "เลือกบัญชีแล้ว รอกดแนบเอกสาร"
              }}</span
            >
            <div class="w-100 border-top-NEXT mx-3 mt-3" />
            <b-col class="pt-3">
              <b-row v-for="(item, key) in objAcc" :key="key" class="">
                <b-col cols="2" align-self="center">
                  <!-- style="padding: 0px !important;" -->
                  <b-img
                    center
                    height="40"
                    width="40"
                    :src="icon_ktb_bookbank"
                  ></b-img>
                </b-col>
                <b-col class="content-nowrap pl-3" cols="8" align-self="center">
                  <span class="font-kanit-bold-16 text-kanit-color-black">{{
                    item.accountName
                  }}</span>
                  <div class="w-100" />
                  <span class="font-kanit-regular-14">
                    {{ covertAccountType(item.productGrp) }}
                    {{ maskAccountNo(item.accountNo) }}
                  </span>
                </b-col>
                <div
                  v-if="key < objAcc.length - 1"
                  class="w-100 border-top-NEXT mx-3 my-3"
                />
              </b-row>
            </b-col>
          </b-row>
          <b-row v-if="item.type == 2">
            <template
              v-if="
                'RESUBMIT' === userData.followupStatus.code &&
                documentType.state == 'wait'
              "
            >
              <div class="w-100" />
              <b-col class="mt-2"
                ><span class="text-kanit-color-orange"
                  >ขอเอกสารเพิ่มเติม</span
                ></b-col
              >
            </template>
            <template v-else-if="getSizeUpload() != ''">
              <div class="w-100" />
              <b-col v-if="documentType.state != 'error'"
                ><span
                  :class="
                    checkDocIsSuccess()
                      ? 'text-kanit-color-success'
                      : 'text-kanit-color-blue'
                  "
                  class="font-kanit-regular-14"
                  >{{ getSizeUpload() }}</span
                ></b-col
              >
              <b-col v-else>
                <span class="font-kanit-regular-14 text-kanit-color-danger"
                  >อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง
                </span>
              </b-col>
            </template>
          </b-row>
        </b-card>
      </div>
      <!-- Button -->
      <div>
        <b-row v-if="!checkDocIsSuccess()">
          <b-col align-self="center">
            <button
              @click="goback()"
              :disabled="checkRequire() || documentType.state === 'error'"
              class="btn btn-block btn-submit-landing-page"
              style="letter-spacing: 0px"
            >
              {{ "แนบเอกสาร" }}
            </button>
          </b-col>
        </b-row>
      </div>

      <!-- modal back-->

      <b-modal
        v-model="modalShowBackStep"
        hide-header
        hide-header-close
        hide-footer
        content-class="content-dialog-back"
      >
        <div class="justify-content-center py-4">
          <b-row>
            <b-col style="text-align: center"
              ><span class="font-kanit-bold-20 text-kanit-color-black"
                >ยืนยันการออกจากหน้านี้?</span
              ></b-col
            >
          </b-row>
          <b-row class="pt-2">
            <b-col style="text-align: center">
              <span class="font-kanit-regular-16 text-kanit-color-black"
                >เอกสารที่เลือกไว้จะไม่ถูกบันทึก</span
              ></b-col
            >
          </b-row>

          <b-row class="pt-4">
            <b-col cols="6">
              <b-button
                class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
                @click="modalShowBackStep = !modalShowBackStep"
              >
                <span class="">ยกเลิก</span>
              </b-button>
            </b-col>

            <b-col cols="6">
              <b-button
                class="btn-block btn btn-info btn-confirm-file-duplication"
                @click="clearData()"
              >
                <span class="">ออกจากหน้านี้</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    grpId: { type: String, required: true },
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  mounted() {
    if (this.userData.accountSelected != undefined) {
      this.objAcc = this.userData.listAccount.filter((i) =>
        this.userData.accountSelected.includes(i.accountNo)
      );
    }
    if (this.userData.dStatementSelected != null) {
      this.dStatementSelected = this.userData.dStatementSelected;
    }

    this.documentType = this.userData.documentType.find(
      (v) =>
        v.doc_code ==
        this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        ).lst_doc_id[0]
    );
    this.$store.dispatch("setUserData", this.userData);

    window.onMobileBackPressed = function () {
      console.log("onMobileBackPressed");
      this.goToPreviousPage();
      return true;
    };
  },
  data() {
    return {
      imgBgNEXT: require("@/assets/images/ic_upload.png"),
      updateType: [],
      objAcc: [],
      icon_recommend: require("@/assets/images/iconRecommendFill.png"),
      icon_ktb_bookbank: require("@/assets/images/BankLogo/KTB.png"),
      imgArrowRight: require("@/assets/images/foundationIconSimpleSystemArrowRight@3x.png"),
      dStatementSelected: false,
      uploaded: null,
      documentType: {},
      modalShowBackStep: false,
      currentMenu: null,
    };
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    this.currentMenu = {
      pageCode: "CommonStatementDocument",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      ).grp_name,
      previousPage: this.userData.routerPath.landing,
      isShow: true,
    };
    this.$event.$emit("update_current_menu", this.currentMenu);
    this.initUpdateType();
  },
  methods: {
    initUpdateType() {
      this.updateType = [];
      this.updateType.push({
        type: 1,
        uploads_message: "Statement จากบัญชีกรุงไทย",
        uploads_desc_message: "สะดวก รวดเร็ว ไม่ต้องอัปโหลดเอกสาร",
        active_flag: this.userData.haveListAccount,
      });
      this.updateType.push({
        type: 2,
        uploads_message: "แนบ Statement ด้วยตนเอง",
        uploads_desc_message: "รองรับไฟล์ JPG, PNG, HEIC และ PDF",
        active_flag: true,
      });
    },
    goToPreviousPage() {
      const docType = this.userData.documentType.find(
        (v) => v.doc_code == this.getDocCode()
      );
      if (docType.state == "success") {
        this.goback();
        return;
      }

      if (
        (this.userData.accountSelected === undefined ||
          (this.userData.accountSelected != undefined &&
            this.userData.accountSelected.length == 0)) &&
        docType.filesReal.length == 0
      ) {
        this.goback();
      } else {
        this.modalShowBackStep = true;
      }
    },

    getDocCode() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      return document_group_type.lst_doc_id[0];
    },
    clearData() {
      this.userData.accountSelected = [];
      this.userData.documentType.find(
        (v) => v.doc_code == this.getDocCode()
      ).filesReal = [];
      this.userData.documentType.find(
        (v) => v.doc_code == this.getDocCode()
      ).realFiles = [];
      this.goback();
    },
    goback() {
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    goTo(type, flag) {
      if (!flag) return;
      if (1 === type && this.checkDocIsSuccess()) return;
      if (1 === type) {
        this.$router.push({
          name: this.userData.routerPath.listAccount,
          param: {
            checkDocIsSuccess: this.checkDocIsSuccess(),
          },
        });
      } else if (2 === type) {
        let document_group_type = this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        );
        this.$router.push({
          name: this.userData.routerPath.uploadOtherBanks,
          params: {
            doc_code: document_group_type.lst_doc_id[0],
            grpId: this.grpId,
          },
        });
      } else if (3 === type) {
        this.$router.push({
          name: this.userData.routerPath.dStatement,
          param: {
            checkDocIsSuccess: this.checkDocIsSuccess(),
          },
        });
      }
    },
    maskAccountNo(value) {
      return (
        "***" +
        " " +
        "*" +
        " " +
        "**" +
        value.substring(6, 9) +
        " " +
        value.substring(9, 10)
      );
    },
    checkDocIsSuccess() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let docType = this.userData.documentType.find(
        (v) => v.doc_code == docCode
      );
      return docType.state != undefined && docType.state == "success";
    },
    getSizeUpload() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let sizeDoc = this.userData.documentType.find(
        (v) => v.doc_code == docCode
      ).filesReal?.length;
      if (sizeDoc > 0) {
        if (this.checkDocIsSuccess()) {
          return "อัปโหลดสำเร็จ";
        } else {
          return "เลือกเอกสารแล้ว รอกดแนบเอกสาร";
        }
      }
      return "";
    },
    checkRequire() {
      if (this.checkDocIsSuccess()) return false;
      let check = true;
      let type = this.updateType.filter((item) => item.active_flag);
      for (let item of type) {
        if (
          (item.type == 1 && this.objAcc.length > 0) ||
          (item.type == 2 && this.getSizeUpload() != "") ||
          (item.type == 3 && this.dStatementSelected)
        ) {
          check = false;
          break;
        }
      }
      return check;
    },
    getHistoryUploads() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let history = this.userData.historyUploads.find(
        (i) => i.doc_code == docCode
      );
      return history.doc_upload_date !== null;
    },
    getSizeFileUploadsMB(realFiles) {
      let bytes = 0;
      realFiles.forEach((i) => {
        bytes = bytes + i.filesize;
      });
      return (bytes / (1024 * 1024)).toFixed(1);
    },
    showDstatementMessage() {
      return this.userData.showDStatementErrorMsg;
    },
    calMarginTop() {
      var h = window.innerHeight;
      let defaultVal = 27;
      if (h < 800) defaultVal = defaultVal - 25;
      if (this.dStatementSelected) {
        defaultVal = defaultVal - 9;
      }
      if (this.getSizeUpload() != "") {
        defaultVal = defaultVal - 2;
      }
      if (this.objAcc.length != 0) {
        defaultVal = defaultVal - 10 * this.objAcc.length;
      }
      if (defaultVal < 0) return 0;
      return defaultVal;
    },
    covertAccountType(productGrp) {
      switch (productGrp) {
        case "SAV":
          return "ออมทรัพย์";
        default:
          return "กระแสรายวัน";
        // default:
        //   return "not found";
      }
    },
  },
};
</script>

<style scoped>
.upload-type > .title {
  color: #000000;
}
.upload-type > .footer > button {
  color: #00a3e4;
  background-color: white;
  border-color: #00a3e4;
  font-size: 0.75rem;
}
.upload-type > .body,
.text-grey {
  color: #8e94a4;
}
.text-wait-upload {
  color: rgb(236, 146, 14);
}
.text-upload {
  color: rgb(99, 190, 0);
}
.text-upload-error {
  color: rgb(219, 0, 0);
}
.card-disable {
  color: rgb(138, 159, 171) !important;
  cursor: not-allowed !important;
  background-color: rgb(234, 240, 245) !important;
  border-radius: 15px !important;
}
.content-nowrap {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: unset;
}
</style>
